export enum CheckoutDepositState {
	SUCCESS = "success",
	FAILURE = "failure",
	PENDING = "pending",
	POTENTIAL_FRAUD = "potential_fraud",
	MANUAL_APPROVAL = "manual_approval"
}
